import React from 'react';
import {Text, View, ImageSourcePropType} from 'react-native';
import {images} from '../../../assets/icons';
import {ECard, Transport} from '../../../assets/images';
import {ContactsCard} from '../../../shared/components/contactsCard';
import {Hr} from '../../../shared/components/hr';
import {Image} from '../../../shared/components/image';
import {ResponsiveView} from '../../../shared/components/responsiveView';
import {useStyles} from '../../../shared/hooks/styles';
import {useIsDesktop} from '../../../shared/hooks/useIsDesktop';
import {formatPhone, formatUrl} from '../../../shared/pipes';
import {openExternalLink, openExternalPhone} from '../../../shared/pipes/openExternalLinks';
import {DeviceSize, useDeviceSize} from '../../../shared/theme/helpers';
import {CardFeatures} from '../components/cardFeatures';
import {CardReplenishment} from '../components/cardReplenishment';
import {ECardInfo} from '../components/eCardInfo';
import {Props} from './model';
import {ContentWithRightImage} from '../../../shared/components/contentWithRightImage';
import {useIsSmallScreenDevice} from '../../../shared/hooks/useIsSmallScreenDevice';

export default ({content}: Props) => {
  const isDesktop = useIsDesktop();
  const deviceSize = useDeviceSize();
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      container: {
        ...mediaOnly(DeviceSize.desktop, {marginBottom: theme.screen.bottomOffset}),
      },
      sectionWithImageContainer: {
        paddingBottom: 40,
      },
      sectionWithImageContent: mediaOnly(DeviceSize.desktop, {
        minHeight: 0,
        maxWidth: '60%',
        width: 820,
      }),
      sectionWithImageBg: mediaOnly(DeviceSize.desktop, {
        width: 444,
        height: 457,
        top: -93,
      }),
      sectionWithImageIcon: {
        top: -93,
        left: -35,
      },
      featuresTitle: {
        ...mediaOnly(
          DeviceSize.desktop,
          {
            ...theme.fonts.h3Light,
          },
          {
            ...theme.fonts.bodySmallLight,
          },
        ),
        color: theme.color.textColor,
      },
      featuresTitleWrapper: mediaOnly(DeviceSize.desktop, {
        marginBottom: 20,
      }),
      cardInfoWrapper: {
        marginBottom: isDesktop ? 40 : 20,
      },
    };
  });

  const isSmallDevice = useIsSmallScreenDevice();
  const imageSizes = {
    width: deviceSize === DeviceSize.desktop ? 173 : isSmallDevice ? 280 : 315,
    height: deviceSize === DeviceSize.desktop ? 147 : isSmallDevice ? 210 : 240,
  };

  const bottomContent = (
    <>
      <View style={styles.featuresTitleWrapper}>
        {isDesktop ? (
          <Text testID='nonfinancial-transport-card-description-id' style={styles.featuresTitle}>
            {content.services.transportService.nonFinancial.descriptionDesktop}
          </Text>
        ) : null}
      </View>
      <ResponsiveView only={[DeviceSize.desktop]}>
        <CardFeatures />
      </ResponsiveView>
      <Hr marginBottom={0} marginTop={isDesktop ? 20 : 20} />
      <View style={{marginTop: 10}}>
        <ContactsCard
          contacts={[
            {
              icon: images.Phone,
              value: formatPhone(content.services.transportService.nonFinancial.eCardSupportPhone),
              onPress: () => openExternalPhone(content.services.transportService.nonFinancial.eCardSupportPhone),
            },
            {
              icon: images.Globe,
              value: formatUrl(content.ekartaContacts.website),
              onPress: () => openExternalLink(content.ekartaContacts.website),
            },
          ]}
          imageProps={{
            source: ECard as ImageSourcePropType,
            width: imageSizes.width,
            height: imageSizes.height,
          }}
        />
      </View>
    </>
  );

  return (
    <View style={styles.container}>
      <ContentWithRightImage
        containerStyle={styles.sectionWithImageContainer}
        contentStyle={styles.sectionWithImageContent}
        backgroundStyle={styles.sectionWithImageBg}
        iconStyle={styles.sectionWithImageIcon}
        icon={<Image source={Transport as any} width={292} height={312} />}>
        <View style={styles.cardInfoWrapper}>
          <ECardInfo />
        </View>
        <CardReplenishment />
        <ResponsiveView exclude={[DeviceSize.desktop]}>{bottomContent}</ResponsiveView>
      </ContentWithRightImage>
      <ResponsiveView only={[DeviceSize.desktop]}>{bottomContent}</ResponsiveView>
    </View>
  );
};
